export { default as OldPaymentMethodSwitcher } from './ui/OldPaymentMethodSwitcher'
export { default as PaymentMethodSwitcher } from './ui/redesign/PaymentMethodSwitcher'
